import { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Marker, Polyline, Popup, useMapEvents, GeoJSON } from "react-leaflet";
import { divIcon, DomEvent, icon } from "leaflet";
import hash from "object-hash";
import { lineString } from "@turf/helpers";
import bezierSpline from "@turf/bezier-spline";

import { Box, Button, Card, Stack, Typography } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changePointPosition, removePoint } from "Redux/pointsSlice";
import DestinationIcon from "Assets/Images/Survey/destination-icon.svg";
import SourceIcon from "Assets/Images/Survey/source-icon.svg";
import { LOGO } from "Configs/core";
import { changeSelectLocMode, setSelectedLoc, changeShowAddSurvayModal, changeShowAddStationModal } from "Redux/mapSlice";
import { changeModal } from "Redux/modalSlice";

const ICON_SIZE = 65;

export default function AddSurvay() {
  const dispatch = useAppDispatch();
  const { selectLocMode, center, selectedLoc, selectLocFor } = useAppSelector((state) => state.map);

  const handleSelect = () => {
    if (selectLocMode === 1) {
      dispatch(changeSelectLocMode(2));
      const Loc = [...selectedLoc];
      Loc[0] = center;
      dispatch(setSelectedLoc(Loc));
    }
    if (selectLocMode === 2) {
      dispatch(changeSelectLocMode(3));
      const Loc = [...selectedLoc];
      Loc[1] = center;
      dispatch(setSelectedLoc(Loc));
    }
    if (selectLocMode === 3) {
      if (selectLocFor === "add-survay") {
        dispatch(changeShowAddSurvayModal(true));
      }
      dispatch(changeSelectLocMode(0));
    }
  };

  const handlePrev = () => {
    if (selectLocMode === 3) {
      dispatch(changeSelectLocMode(2));
    }
    if (selectLocMode === 2) {
      dispatch(changeSelectLocMode(1));
    }
    // if (selectLocMode === 1) {
    //   dispatch(changeSelectLocMode(2));
    //   const Loc = [...selectedLoc];
    //   Loc[0] = center;
    //   dispatch(setSelectedLoc(Loc));
    // }
  };

  const mode = () => {
    if (selectLocMode === 1) {
      return "انتخاب مبدا";
    }
    if (selectLocMode === 2) {
      return "انتخاب مقصد";
    }
    if (selectLocMode === 3) {
      return "ادامه";
    }
  };

  return (
    <Stack sx={{ flexGrow: 1, justifyContent: "center" }} direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={1}>
        <Button variant="white" size="large" style={{ width: "200px" }} onClick={handleSelect}>
          {mode()}
        </Button>
        <Button variant="white" size="large" style={{ width: "200px" }} disabled={selectLocMode === 1} onClick={handlePrev}>
          قبلی
        </Button>
      </Stack>
    </Stack>
  );
}
